import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from '@app/app.config.provider';
import { IAcquisition } from '@models/acquisition';
import { StoreActions } from '@models/store/store-actions';
import { IStoreState } from '@models/store/store-state';
import { ObservableStore } from '@services/observable-store/dist';
import { getAcquisitionNames } from '@shared/get-acquisition-names';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AcquisitionService extends ObservableStore<IStoreState> {
  private ACQUISITIONS_ENDPOINT: string;

  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfigProvider) {
    super({ trackStateHistory: false });

    this.appConfig.environment.subscribe(env => {
      this.ACQUISITIONS_ENDPOINT = `${env.API.REFERENCE_DATA}/api/acquisitions`;
    });
  }

  public getAcquisitions(): Observable<IAcquisition[]> {
    const state = this.getState();
    if (state && state.acquisitions) {
      return of(state.acquisitions);
    } else {
      return this.fetchAcquisitions();
    }
  }

  public fetchAcquisitions() {
    return this.http.get<IAcquisition[]>(this.ACQUISITIONS_ENDPOINT).pipe(
      map(acquisitions => {
        if (!acquisitions) {
          acquisitions = [];
        }

        // Sorting acquisitions from most to less recent
        acquisitions.sort((a1, a2) => new Date(a1.AcquisitionDate).getTime() - new Date(a2.AcquisitionDate).getTime());
        this.setState({ acquisitions }, StoreActions.SetAcquisitions);

        return acquisitions;
      }),
      retry(3),
      catchError(this.handleError)
    );
  }

  public getAcquisitionNames(acquisitions: IAcquisition[], acquisitionIds: number[] | string): string {
    return getAcquisitionNames(acquisitions, acquisitionIds);
  }

  private handleError(error: any) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Server error');
  }
}
